
import { GuessHistory } from "@/lib/types/GameTypes";
import { isCloseGuess } from "@/components/game/GameLogic";

// Calculate the total score based on guess history and failure level
export const calculateTotalScore = (
  guessHistory: GuessHistory,
  failedAtLevel?: number
): number => {
  // If there's no guess history, return max score (worst possible)
  if (!guessHistory || !Array.isArray(guessHistory) || guessHistory.length === 0) {
    return 30; // Maximum possible score
  }

  let totalScore = 0;
  console.log('Calculating score with:', {
    historyLength: guessHistory.length,
    failedAtLevel,
    guessHistory: JSON.stringify(guessHistory)
  });

  // Process each level's guess history
  for (let level = 1; level <= 4; level++) {
    const levelHistory = guessHistory.find(h => h.level === level);
    const maxAttempts = 7 - level; // Maximum attempts for each level: 6,5,4,3
    
    if (levelHistory && levelHistory.guesses && levelHistory.guesses.length > 0) {
      // Get the last guess to check if level was completed successfully
      const lastGuess = levelHistory.guesses[levelHistory.guesses.length - 1];
      const levelSuccessful = lastGuess.every(letter => letter.status === "correct");
      const attemptCount = levelHistory.guesses.length;
      
      console.log(`Level ${level} score:`, {
        attempts: attemptCount,
        successful: levelSuccessful,
        isFailed: level === failedAtLevel,
        maxAttempts: maxAttempts
      });
      
      if (levelSuccessful && (!failedAtLevel || level < failedAtLevel)) {
        // Count score for successful level completion:
        // - Previous attempts: yellow boxes (2 points) or red boxes (3 points)
        // - Final attempt counts as green boxes (1 point)
        let previousAttemptsScore = 0;
        
        // Score each previous attempt
        for (let i = 0; i < attemptCount - 1; i++) {
          const attemptGuess = levelHistory.guesses[i];
          if (isCloseGuess(attemptGuess)) {
            previousAttemptsScore += 2; // Yellow box
          } else {
            previousAttemptsScore += 3; // Red box
          }
        }
        
        const greenBoxes = 1; // Final successful attempt
        totalScore += previousAttemptsScore + greenBoxes;
        console.log(`Level ${level}: ${previousAttemptsScore} (previous attempts) + ${greenBoxes} (green) points`);
      } else if (level === failedAtLevel) {
        // Failed level: yellow boxes (2 points) or red boxes (3 points)
        let failedLevelScore = 0;
        
        for (let i = 0; i < attemptCount; i++) {
          const attemptGuess = levelHistory.guesses[i];
          if (isCloseGuess(attemptGuess)) {
            failedLevelScore += 2; // Yellow box
          } else {
            failedLevelScore += 3; // Red box
          }
        }
        
        totalScore += failedLevelScore;
        console.log(`Level ${level}: ${failedLevelScore} points (failed level)`);
      }
    } 
    
    // Handle unattempted levels (both after failure and regular unattempted)
    if ((!levelHistory || !levelHistory.guesses || levelHistory.guesses.length === 0) ||
        (failedAtLevel && level > failedAtLevel)) {
      // Calculate black box score based on max attempts for this level
      // Each unattempted level now counts as 10 points per available attempt
      const blackBoxes = maxAttempts * 10;
      totalScore += blackBoxes;
      console.log(`Level ${level}: ${blackBoxes} (black) points (unattempted level)`);
    }
  }
  
  console.log(`Final score: ${totalScore}`);
  return totalScore;
};
